export default {
  footer: state => state.app.footer,
  homeActive: state => state.app.homeActive,
  home: state => state.app.home,
  token: state => state.app.token,
  isLogin: state => !!state.app.uid,
  qx: state => state.app.qx,
  uid: state => state.app.uid,
  dm_id: state => state.app.dm_id,
  backgroundColor: state => state.app.backgroundColor,
  userInfo: state => state.app.userInfo || {},
  storeItems: state => state.app.storeItems || {},
  goName: state => state.app.goName
};
